export const hasPercentList:string[] = [
  'd2', 'd3', 'd7', 'weighted_d2', 'weighted_d3', 'weighted_d7',
  'w2', 'w3', 'weighted_w2', 'weighted_w3',
  'm2', 'm3', 'weighted_m2', 'weighted_m3',
  'payer_ratio'
]